import { render, staticRenderFns } from "./Lkl.vue?vue&type=template&id=0d0817fc&scoped=true&"
import script from "./Lkl.vue?vue&type=script&lang=js&"
export * from "./Lkl.vue?vue&type=script&lang=js&"
import style0 from "./Lkl.vue?vue&type=style&index=0&id=0d0817fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0817fc",
  null
  
)

export default component.exports